import { createSlice } from '@reduxjs/toolkit';

export const initialState = {};

const LogoutSlice = createSlice({
    name: 'logout',
    initialState,
    reducers: {
        logout: state => {},
    },
    extraReducers: builder => {},
});

export const LogoutReducer = LogoutSlice.reducer;
export const LogoutActions = {
    ...LogoutSlice.actions,
};
